export default "__VITE_ASSET__7KuA81Im__"